import { createContext, useContext, useState, useEffect } from "react";
import { apiFetch } from "../../hooks/apiFetch";
import { useUser } from "./UserContext";

const UserCartContext = createContext();

export function UserCartProvider({ children }) {
    const [loading, setLoading] = useState(true);
    const [cartBooks, setCartBooks] = useState(null);
    const [cartOrders, setCartOrders] = useState(null);
    const [cartStats, setCartStats] = useState(null);
    const [currentPageBooks, setCurrentPageBooks] = useState(1);
    const [currentPageOrders, setCurrentPageOrders] = useState(1);
    const { isLogIn } = useUser();

    useEffect(() => {
        if (!isLogIn) {
            setCartBooks(null);
            setCartOrders(null);
            setCartStats(null);
            setLoading(false);
            return;
        }
        async function fetchCartItems() {
            try {
                const booksData = await apiFetch(`${process.env.REACT_APP_MASAR_API_URL}/carts/my-cart/books?page=${currentPageBooks}&limit=3`);
                const ordersData = await apiFetch(`${process.env.REACT_APP_MASAR_API_URL}/carts/my-cart/orders?page=${currentPageOrders}&limit=4`);
                const cartStatsData = await apiFetch(`${process.env.REACT_APP_MASAR_API_URL}/carts/my-cart/statistics`);

                setCartBooks(booksData);
                setCartOrders(ordersData);
                setCartStats(cartStatsData);
            } catch (err) {
                setCartBooks(null);
                setCartOrders(null);
                setCartStats(null);
            }
            finally {
                setLoading(false);
            }
        }
        fetchCartItems();
        // }
    }, [currentPageOrders, currentPageBooks, isLogIn]);

    return (
        <UserCartContext.Provider
            value={{
                loading, cartBooks, setCartBooks, cartOrders, setCartOrders,
                cartStats, setCartStats, currentPageBooks, setCurrentPageBooks,
                currentPageOrders, setCurrentPageOrders, setLoading
            }}>
            {children}
        </UserCartContext.Provider>
    );
}

export function useUserCart() {
    return useContext(UserCartContext);
}